export default ({ message = "", className }) => (
    <div className={`warning ${className && className}`}>
        <div className="warning-exclamation">!</div>
        <p>{message}</p>
    </div>
);
